export default __webpack_public_path__ + "static/media/Marcelo Oliveira_.1774d05b.png";